import { render, staticRenderFns } from "./exhibition-down.vue?vue&type=template&id=21f36f76&scoped=true&"
import script from "./exhibition-down.vue?vue&type=script&lang=js&"
export * from "./exhibition-down.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-down.vue?vue&type=style&index=0&id=21f36f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f36f76",
  null
  
)

export default component.exports